import {create} from "zustand";
import {persist} from 'zustand/middleware'
import {TokensResponseDto} from "@/@types/auth.types.ts";

type AuthTokensStore = {
    tokens?: TokensResponseDto;
    setTokens: (tokens?: TokensResponseDto) => void;
    clearTokens: () => void;
};

// persist store to local storage
export const useAuthTokens = create<AuthTokensStore>()(
    persist(
        (set) => ({
            tokens: undefined,
            setTokens: (tokens?: TokensResponseDto) => set({tokens}),
            clearTokens: () => set({tokens: undefined}),
        }),
        {
            name: 'owninn-portal-auth-tokens-storage', // name of the item in the storage (must be unique)
            //@ts-ignore
            getStorage: () => localStorage, // (optional) by default the 'localStorage' is used
        }
    )
);

